<template>
  <div class="ag-grid-search-floating-filter" @click="showFilter">
    <input
      class="ag-floating-filter-input"
      type="text"
      readonly
      :placeholder="placeholder"
      :title="label"
      :value="label">
  </div>
</template>

<script>
import Vue from 'vue'

/**
 * Floating filter for the columns filtered by AgGridSearchFilter. ag-grid only builds one of these
 * itself for its own filters, and the column menu is hidden on these grids, so this is what shows
 * the current selection and opens the search.
 *
 * Configured through the column's floatingFilterComponentParams:
 *   placeholder   Shown while nothing is selected, e.g. 'Vendor'
 */
export default Vue.extend({
  name: 'AgGridSearchFloatingFilter',

  data () {
    return {
      label: ''
    }
  },

  computed: {
    placeholder () {
      return this.params.placeholder || ''
    }
  },

  methods: {
    /**
     * ag-grid IFloatingFilterComp: the parent filter's model changed
     * @param parentModel
     */
    onParentModelChanged (parentModel) {
      this.label = parentModel && Array.isArray(parentModel.names) ? parentModel.names.join(', ') : ''
    },
    showFilter () {
      this.params.showParentFilter()
    }
  }
})
</script>

<style scoped>
  .ag-grid-search-floating-filter {
    width: 100%;
  }
  .ag-grid-search-floating-filter input {
    width: 100%;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/SigmaClientNew/AgGridSearchFloatingFilter.vue